module.exports = {
  responsive: true,
  aspectRatio: window.innerWidth > 992 ? 16 / 9 : 1,
  onResize: function(chartObj) {
    chartObj.aspectRatio = window.innerWidth > 992 ? 16 / 9 : 1;
    chartObj.update()
  },
  scales: {
    yAxes: [{
      ticks: {
        beginAtZero: false
      },
      scaleLabel: {
        display: true,
        labelString: 'Deaths per 100K'
      }
    }],
    xAxes: [{
      scaleLabel: {
        display: true,
        labelString: 'Year'
      }
    }]
  }
}